export default __webpack_public_path__ + "static/media/nasscom-logo.ebcf0b18.png";